import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Skeleton } from '@/components/ui/skeleton.component';

export function ProfileSkeleton() {
  return (
    <Skeleton
      data-testid={DataTestIdEnum.HEADER_PROFILE_LOADING}
      className="w-8 h-8 rounded-lg"
    />
  );
}

export function LoginButtonSkeleton() {
  return (
    <Skeleton
      data-testid={DataTestIdEnum.HEADER_LOGIN_LOADING}
      className="w-20 h-8 rounded-lg"
    />
  );
}
